import {
  getToken
} from "@/util/cookie"
import {
  getUserInfo
} from "@/api/auth"

export default {
  methods: {
    login() {
      let uid = this.$route.query.uid || ''
      if (uid) {
        const query = {
          ...this.$route.query
        }
        delete query.uid
        this.$router.replace({
          query
        })
        this.$store.dispatch("setUserInfo", uid)
      } else if (!getToken()) {
        location.href = 'http://61.156.14.15:8181/api' + "/hsp_identity" + "/api/identity/shandong/login?backUrl=" +
          window.location.href
      } else {}
    },
    getUser(callback) {
      let uid = getToken()
      if (!uid) {
        this.login()
      }
      getUserInfo(uid).then(res => {
        callback(res)
      })
    }
  }
}